// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 设备管理
import Home from '@/views/home/Home';
import Machine from '@/views/machine/Machine';
import machineOverview from '@/views/machineOverview';
import alarmOverview from '@/views/alarmOverview';
import patientOverview from '@/views/patientOverview';
import systemOverview from '@/views/systemOverview';
import realTime from '@/views/realTime';
// 报警或故障信息管理
import Alarm from '@/views/alarm/Alarm';
// 患者管理
import Patient from '@/views/patient/Patient';
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 美容中心管理
import Dept from '@/views/system/Dept';
// 版本管理
import version from '@/views/system/version';
// 历史管理
import history from '@/views/system/history';


// 机器信息管理
// import Machine from '@/views/machine/Machine';
// 货道信息管理
// import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
// import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: 'Login',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: 'Home',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/home/Home',
            name: 'Home',
            component: Home,
            meta: {
                requireAuth: true
            }
        },
          {
            path: '/machine/Machine',
            name: 'Machine List',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/alarm/Alarm',
            name: 'Alarm Notification',
            component: Alarm,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/patient/Patient',
            name: 'User List',
            component: Patient,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: 'Account List',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: 'Role List',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: 'Beauty Center List',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/version',
            name: 'Version List',
            component: version,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/history',
            name: 'History List',
            component: history,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machineOverview',
            name: 'Machine Overview',
            component: machineOverview,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/alarmOverview',
            name: 'Alarm Overview',
            component: alarmOverview,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/patientOverview',
            name: 'User Overview',
            component: patientOverview,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/systemOverview',
            name: 'System Overview',
            component: systemOverview,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/realTime',
            name: 'Real Time',
            component: realTime,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js